module.exports = __webpack_public_path__ + "static/media/headline.7300149d.png";